import { AuthenticationService } from "../../core/services/auth/auth.service";
import { LoaderService } from "./../../core/services/loader.service";
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";

@Injectable()
export class Interceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(
    private _auth: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let request = req.clone({});

    this.requests.push(req);
    this.loaderService.isLoading.next(true);

    // if token exits will be added to request headers

    if (this._auth.Token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this._auth.Token}`,
          "device-push-token": `${this._auth.User.firebase_token}`
            ? `${this._auth.User.firebase_token}`
            : "Not Allowed",
        },
      });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.status === 200) {
              this.removeRequest(req);
            } else if (event.status === 403) {
              this._auth.expiredTokenSubject.next(true);
              localStorage.removeItem("user");
              this.router.navigate(["/account/login"]);
              this.removeRequest(req);
            }
          }
        },
        (err: any) => {
          this.removeRequest(req);

          if (err instanceof HttpErrorResponse) {
            if (err.error.message === "Unauthenticated") {
              this._auth.expiredTokenSubject.next(true);
              localStorage.removeItem("user");
              this.router.navigate(["/account/login"]);
            }
            if (err.status == 403) {
              this._auth.expiredTokenSubject.next(true);
              localStorage.removeItem("user");
              this.router.navigate(["/account/login"]);
              this.removeRequest(req);
              Swal.fire("خطأ ", `${err.error.message}`, "error");
            }
          }
          this.removeRequest(req);

          return of(err);
        }
      )
    );
  }
}
